/* eslint-disable */
import React, { Component } from 'react';
import axios from 'axios';
import config from '../../config';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    Typography,
    Button,
    CircularProgress,
    Snackbar,
    RadioGroup,
    FormControlLabel,
    Radio,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

class BRSRDynamicForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            saving: false,
            structures: [],
            structures: [],
            responses: {},
            toast: { open: false, type: 'info', msg: '' },
            variableRows: {}, // Track row count for variable tables { structureId: count }
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    /** Fetch structures + existing responses */
    fetchData = async () => {
        const { cardId, financialYear } = this.props;
        this.setState({ loading: true });

        try {
            const [structRes, dataRes] = await Promise.all([
                axios.get(`${config.laravelBaseUrl}brsr/structures`, {
                    params: { card_id: cardId, financial_year: financialYear },
                    headers: { Authorization: "Bearer " + sessionStorage.getItem("userToken") }
                }),
                axios.get(`${config.laravelBaseUrl}brsr/data`, {
                    params: { card_id: cardId, financial_year: financialYear },
                    headers: { Authorization: "Bearer " + sessionStorage.getItem("userToken") }
                })
            ]);

            console.log("BRSR Structure Response:", structRes.data);

            // ✅ Get structures from new API format
            const structures = structRes.data?.data?.structures || [];

            const existingData = dataRes.data?.data || [];
            const responseMap = {};
            const variableRows = {};

            existingData.forEach((item) => {
                const key = `${item.structure_id}_${item.pos_serial_no}`;
                responseMap[key] = {
                    value: item.value_text,
                    structure_id: item.structure_id,
                    pos_serial_no: item.pos_serial_no,
                };

                // Logic to recover row counts for variable tables
                // Assumes composite key: (RowIndex * 10000) + ColumnID
                // Only applicable if structure is Variable Nature. 
                // We need to check structure ID against loaded structures?
                // Or just safeguard: if pos_serial_no > 10000 implies composite?
                if (item.pos_serial_no >= 10000) {
                    const rowIndex = Math.floor(item.pos_serial_no / 10000);
                    // Store max row index found for this structure
                    if (!variableRows[item.structure_id] || rowIndex > variableRows[item.structure_id]) {
                        variableRows[item.structure_id] = rowIndex;
                    }
                }
            });

            // Normalize variableRows to ensure at least 1 row if none found, or maintain found count
            structures.forEach(s => {
                if (s.structure_nature === 'Variable') {
                    if (!variableRows[s.structure_id]) {
                        variableRows[s.structure_id] = 1; // Default 1 row
                    }
                }
            });

            this.setState({ structures, responses: responseMap, variableRows, loading: false });
        } catch (error) {
            console.error("BRSR fetch error:", error);
            this.setState({
                loading: false,
                toast: { open: true, type: "error", msg: "Failed to load data." },
            });
        }
    };

    /** Input change handler */
    handleInputChange = (structureId, rowId, value, rowLabel, varType) => {
        const key = `${structureId}_${rowId}`;
        this.setState(prevState => ({
            responses: {
                ...prevState.responses,
                [key]: {
                    value,
                    structure_id: structureId,
                    pos_serial_no: rowId,
                    question_text: rowLabel,
                    var_type: varType
                }
            }
        }));
    };

    /** Save user-entered data */
    saveResponses = async () => {
        const { cardId, financialYear } = this.props;
        const { responses } = this.state;
        this.setState({ saving: true });

        const responseArray = Object.values(responses).map(resp => ({
            structure_id: resp.structure_id,
            question_id: resp.pos_serial_no,
            response_value: resp.value,
            question_text: resp.question_text,
            var_type: resp.var_type,
            unit_id: 1 // Default, adjust if needed
        }));

        try {
            await axios.post(`${config.laravelBaseUrl}brsr/data/save`, {
                card_id: cardId,
                financial_year: financialYear,
                responses: responseArray
            }, {
                headers: { Authorization: "Bearer " + sessionStorage.getItem("userToken") }
            });

            this.setState({
                saving: false,
                toast: { open: true, type: 'success', msg: 'Saved successfully!' }
            });
        } catch (error) {
            console.error("Save error:", error);
            this.setState({
                saving: false,
                toast: { open: true, type: 'error', msg: 'Failed to save data.' }
            });
        }
    };

    /** Handle adding a row to a variable table */
    handleAddRow = (structureId) => {
        this.setState(prevState => ({
            variableRows: {
                ...prevState.variableRows,
                [structureId]: (prevState.variableRows[structureId] || 0) + 1
            }
        }));
    };

    /** Handle deleting a row from a variable table */
    handleDeleteRow = (structureId, rowIndex, columns) => {
        this.setState(prevState => {
            const currentCount = prevState.variableRows[structureId] || 1;
            if (currentCount <= 1) return null;

            // Cleanup data for the row being removed
            const newResponses = { ...prevState.responses };
            columns.forEach(col => {
                const compositeRowId = (rowIndex * 10000) + col.id;
                const key = `${structureId}_${compositeRowId}`;
                delete newResponses[key];
                // Note: we can't easily delete from DB here without API call. 
                // But preventing it from being sent in next save is good.
                // However, existing DB rows won't be deleted by 'saveResponses' logic (updateOrInsert).
                // To fully delete from DB, we might need a separate API or logic.
                // This requires a backend "Delete" or "Sync" mechanism.
                // Given the constraints, I will leave the DB aspect for now but at least clean UI state.
            });

            return {
                variableRows: {
                    ...prevState.variableRows,
                    [structureId]: currentCount - 1
                },
                responses: newResponses
            };
        });
    };

    /** Render input dynamically based on var_type */
    renderInput = (row, structure) => {
        const { responses } = this.state;
        const key = `${structure.structure_id}_${row.id}`;
        const answer = responses[key]?.value || '';
        const disabled = structure.source_type === 'Data';
        const varType = row.var_type || 'TXT';

        // HEADER and PARENT-HEADER are labels only, no input fields
        if (varType === 'HEADER' || varType === 'PARENT-HEADER') {
            return null;
        }

        switch (varType) {
            case 'NUM':
                return (
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="number"
                        value={answer}
                        onChange={(e) => this.handleInputChange(structure.structure_id, row.id, e.target.value, row.label, varType)}
                        disabled={disabled}
                    />
                );
            case 'PER':
                return (
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        type="number"
                        InputProps={{ endAdornment: <span style={{ color: '#aaa' }}>%</span> }}
                        value={answer}
                        onChange={(e) => this.handleInputChange(structure.structure_id, row.id, e.target.value, row.label, varType)}
                        disabled={disabled}
                    />
                );
            case 'BOOL':
                return (
                    <RadioGroup
                        row
                        value={answer?.toString() || ""}
                        onChange={(e) => this.handleInputChange(structure.structure_id, row.id, e.target.value === "true", row.label, varType)}
                    >
                        <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={disabled} />
                        <FormControlLabel value="false" control={<Radio />} label="No" disabled={disabled} />
                    </RadioGroup>
                );
            case 'MLT':
                return (
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        size="small"
                        value={answer}
                        onChange={(e) => this.handleInputChange(structure.structure_id, row.id, e.target.value, row.label, varType)}
                        disabled={disabled}
                    />
                );
            default:
                return (
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={answer}
                        onChange={(e) => this.handleInputChange(structure.structure_id, row.id, e.target.value, row.label, varType)}
                        disabled={disabled}
                    />
                );
        }
    };

    /** Render structure - handles both table and hierarchical formats */
    renderStructureTable = (structure) => {
        // Check if this is a table structure (has columns) or hierarchical structure (has grouped_rows)
        if (structure.columns && structure.columns.length > 0) {
            return this.renderTableStructure(structure);
        } else if (structure.grouped_rows && structure.grouped_rows.length > 0) {
            return this.renderHierarchicalStructure(structure);
        } else if (structure.rows && structure.rows.length > 0) {
            return this.renderSimpleRows(structure);
        } else {
            return (
                <Typography variant="body2" color="textSecondary">
                    No displayable content for this structure type.
                </Typography>
            );
        }
    };

    /** Render Variable Table (Dynamic Rows) */
    renderVariableTable = (structure) => {
        const { columns } = structure;
        const rowCount = this.state.variableRows[structure.structure_id] || 1;
        const rows = [];

        for (let i = 1; i <= rowCount; i++) {
            rows.push(i);
        }

        return (
            <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                    <TableHead>
                        <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell style={{ width: 50 }}>#</TableCell>
                            {columns.map((col) => (
                                <TableCell key={col.id} style={{ fontWeight: 600 }}>
                                    {col.label}
                                </TableCell>
                            ))}
                            <TableCell style={{ width: 50 }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((rowIndex) => (
                            <TableRow key={rowIndex}>
                                <TableCell>{rowIndex}</TableCell>
                                {columns.map((col) => {
                                    // Check if column is "S. No."
                                    if (col.label === 'S. No.' || col.label === 'S.No.' || col.label === 'Serial No.') {
                                        return (
                                            <TableCell key={col.id}>
                                                {rowIndex}
                                            </TableCell>
                                        );
                                    }

                                    // Construct composite ID for binding
                                    // Serial No = (RowIndex * 10000) + ColumnID
                                    // ColumnID is typically int.
                                    // RowIndex starts at 1.
                                    const compositeRowId = (rowIndex * 10000) + col.id;

                                    // Mock row object for renderInput
                                    const mockRow = {
                                        id: compositeRowId,
                                        label: col.label,
                                        var_type: col.var_type
                                    };

                                    return (
                                        <TableCell key={col.id}>
                                            {this.renderInput(mockRow, structure)}
                                        </TableCell>
                                    );
                                })}
                                <TableCell>
                                    {/* Only allow deleting if it's the last row and we have > 1 rows? 
                                         Or just generic delete handler? 
                                         Using Remove Last Row logic for now.*/}
                                    {rowIndex === rowCount && rowCount > 1 && (
                                        <IconButton size="small" onClick={() => this.handleDeleteRow(structure.structure_id, rowIndex, columns)}>
                                            <DeleteIcon fontSize="small" color="secondary" />
                                        </IconButton>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                        {/* Add Row Button Footer */}
                        <TableRow>
                            <TableCell colSpan={columns.length + 2} align="center">
                                <Button
                                    startIcon={<AddIcon />}
                                    size="small"
                                    onClick={() => this.handleAddRow(structure.structure_id)}
                                    color="primary"
                                >
                                    Add Row
                                </Button>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    /** Render QA specific structure (Question + Text Input) */
    renderQAStructure = (structure) => {
        // Use structure_id (which is the unique Row ID e.g. 96) as the "row ID"
        // And use a dummy row object to leverage existing renderInput logic or build custom one
        const rowId = structure.structure_id;

        // Mock a row object to reuse renderInput or manual input
        // Using renderInput saves duplication of disabled/handler logic
        const mockRow = {
            id: rowId, // This maps to pos_serial_no in save logic if we use renderInput?
            // Wait, saveResponses uses: question_id: resp.pos_serial_no
            // If I use structure_id as rowId, then pos_serial_no = 96.
            // And structure_id = 96.
            // So structure_id = 96, question_id = 96.
            // This is unique and works for QA.
            label: structure.structure_text || structure.structure_name,
            var_type: 'MLT' // QAs usually need multiline text
        };

        return (
            <Paper variant="outlined" style={{ padding: 16 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
                    {structure.structure_text || structure.structure_name}
                </Typography>
                {this.renderInput(mockRow, structure)}
            </Paper>
        );
    };

    /** Render table structure with columns and rows */
    renderTableStructure = (structure) => {
        const { columns, rows } = structure;

        return (
            <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                    <TableHead>
                        <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                            {columns.map((col) => (
                                <TableCell key={col.id} style={{ fontWeight: 600 }}>
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.id}>
                                {columns.map((col, colIndex) => (
                                    <TableCell key={`${row.id}-${col.id}`}>
                                        {colIndex === 0 ? (
                                            // First column shows the row label
                                            <Typography variant="body2">
                                                {row.label}
                                            </Typography>
                                        ) : (
                                            // Other columns show input fields based on row's var_type
                                            this.renderInput(row, structure)
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    /** Render hierarchical structure with parent title and grouped rows */
    renderHierarchicalStructure = (structure) => {
        return (
            <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                    <TableBody>
                        {/* Render parent title if exists */}
                        {structure.parent_title && (
                            <TableRow style={{ backgroundColor: '#e8f4f8' }}>
                                <TableCell colSpan={2} style={{ fontWeight: 700, fontSize: '1rem', padding: '14px' }}>
                                    {structure.parent_title}
                                </TableCell>
                            </TableRow>
                        )}

                        {/* Render sub-headers and their data rows */}
                        {structure.grouped_rows.map((group, groupIndex) => (
                            <React.Fragment key={groupIndex}>
                                {/* Render sub-header row if exists */}
                                {group.header && (
                                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                        <TableCell colSpan={2} style={{ fontWeight: 600, fontSize: '0.9rem', padding: '10px', paddingLeft: '24px' }}>
                                            {group.header.label}
                                        </TableCell>
                                    </TableRow>
                                )}

                                {/* Render data rows under this sub-header */}
                                {group.rows && group.rows.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell style={{ width: '60%', paddingLeft: group.header ? '48px' : '16px' }}>
                                            <Typography variant="body2">
                                                {row.label}
                                            </Typography>
                                        </TableCell>
                                        <TableCell style={{ width: '40%' }}>
                                            {this.renderInput(row, structure)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    /** Render simple rows without columns or headers */
    renderSimpleRows = (structure) => {
        return (
            <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                    <TableBody>
                        {structure.rows.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell style={{ width: '60%' }}>
                                    <Typography variant="body2">
                                        {row.label}
                                    </Typography>
                                </TableCell>
                                <TableCell style={{ width: '40%' }}>
                                    {this.renderInput(row, structure)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    /** Render main structure card */
    renderStructure = (structure) => {
        const isManual = structure.source_type === 'Manual';
        const headerBg = isManual ? '#e3f2fd' : '#f8f9fa';
        const sourceLabel = isManual ? '✏️ User Entry' : '📊 System Data';

        // Determine structure type label
        let structureTypeLabel = '';
        if (structure.structure_nature) {
            structureTypeLabel = structure.structure_nature === 'Fixed' ? 'Fixed Table' : 'Variable Table';
        } else {
            structureTypeLabel = 'Q&A Format';
        }

        return (
            <Card
                key={`${structure.structure_id}_${structure.unit_id}`}
                style={{ marginBottom: 24, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
            >
                <CardHeader
                    title={
                        <Box>
                            <Typography variant="caption" color="textSecondary">
                                {structure.domain} • {structure.sub_domain} • {structureTypeLabel}
                            </Typography>
                        </Box>
                    }
                    subheader={sourceLabel}
                    style={{
                        background: headerBg,
                        borderBottom: '1px solid #dee2e6'
                    }}
                />
                <CardContent>
                    {structure.structure_nature === 'Variable'
                        ? this.renderVariableTable(structure)
                        : (structure.structure_type === 'QA'
                            ? this.renderQAStructure(structure)
                            : this.renderStructureTable(structure)
                        )
                    }
                </CardContent>
            </Card>
        );
    };

    render() {
        const { loading, saving, toast, structures } = this.state;

        if (loading) {
            return (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            );
        }

        if (!structures.length) {
            return (
                <Box p={3}>
                    <Alert severity="info">No structures defined for this card. Please configure the mapping in the database.</Alert>
                </Box>
            );
        }

        return (
            <div id="brsr-dynamic-form">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} className="no-print">
                    <Typography variant="h5" style={{ fontWeight: 600 }}>
                        BRSR Report
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SaveIcon />}
                        onClick={this.saveResponses}
                        disabled={saving}
                        style={{ borderRadius: 8 }}
                    >
                        {saving ? 'Saving...' : 'Save Changes'}
                    </Button>
                </Box>

                {structures.map((structure) => this.renderStructure(structure))}

                <Snackbar
                    open={toast.open}
                    autoHideDuration={3000}
                    onClose={() => this.setState({ toast: { ...toast, open: false } })}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert severity={toast.type}>{toast.msg}</Alert>
                </Snackbar>
            </div>
        );
    }
}

export default BRSRDynamicForm;
